<div class="portfo-assets-container">
  <span class="fw-semi-bold assets-text">کل دارایی شما</span>

  <div class="assets-total-value">
    <div class="d-flex align-items-center gap-5 mt-plus">
      @if (canSee()) {
        <span class="fs-22 font-color">
          {{ assets()?.balance | number }}
        </span>
        <div class="assets-total-unit font-color is-currency">ریال</div>
      } @else {
        <span class="fs-22 font-color"> ********* </span>
      }
    </div>
  </div>

  <div class="mt-medium">
    <!-- <app-funds-unavailable /> -->
    <app-meter-group
      [meters]="assets().balance | meters: assets().portfolioDetails"
      [totalBalance]="assets()?.balance"
    ></app-meter-group>
  </div>
</div>
